import { Shield01 } from '@kula-ai/icons/outline/Shield01';
import { Shield03 } from '@kula-ai/icons/outline/Shield03';
import { ShieldTick } from '@kula-ai/icons/outline/ShieldTick';
import { ShieldOff } from '@kula-ai/icons/outline/ShieldOff';

import { ShieldFaield } from '@/assets/icons/ats';

export type FraudDetectorStatus =
  | 'none'
  | 'failed'
  | 'in_progress'
  | 'no_issues'
  | 'inconclusive'
  | 'suspicious';

export interface FraudDetectorBadgeConfig {
  label: string;
  icon: any;
  iconColor?: string;
  iconBg: string;
  borderColor: string;
  outerBg: string;
  rippleColor?: string;
}

export const FRAUD_DETECTOR_BADGE_CONFIG: Record<
  FraudDetectorStatus,
  FraudDetectorBadgeConfig
> = {
  none: {
    label: 'Not evaluated',
    icon: Shield01,
    iconColor: 'secondary-700',
    iconBg: 'secondary-25',
    borderColor: 'secondary-200',
    outerBg: 'secondary-25',
  },
  failed: {
    label: 'Failed',
    icon: ShieldFaield,
    iconColor: 'secondary-600',
    iconBg: 'secondary-25',
    borderColor: 'secondary-200',
    outerBg: 'secondary-25',
  },
  in_progress: {
    label: 'In progress',
    icon: Shield01,
    iconColor: 'primary-500',
    iconBg: 'primary-100',
    borderColor: 'primary-400',
    outerBg: 'primary-50',
  },
  no_issues: {
    label: 'No issues',
    icon: ShieldTick,
    iconColor: 'pastel-2-dark',
    iconBg: 'pastel-2-light',
    borderColor: 'pastel-2-dark',
    outerBg: 'pastel-2-light',
    rippleColor: '#9FDFB6',
  },
  inconclusive: {
    label: 'Inconclusive',
    icon: Shield03,
    iconColor: 'pastel-6-dark',
    iconBg: 'pastel-6-light',
    borderColor: 'pastel-6-dark',
    outerBg: 'pastel-6-light',
    rippleColor: '#FBC67B',
  },
  suspicious: {
    label: 'Suspicious',
    icon: ShieldOff,
    iconColor: 'pastel-1-dark',
    iconBg: 'pastel-1-light',
    borderColor: 'pastel-1-dark',
    outerBg: 'pastel-1-light',
    rippleColor: '#FFB9A9',
  },
};

export const FRAUD_DETECTOR_STATUSES: FraudDetectorStatus[] = [
  'failed',
  'in_progress',
  'no_issues',
  'inconclusive',
  'suspicious',
];
